import { DEFAULT_HERO_IMAGE_CONFIG } from './scene-image-preparation.js';
import { DEFAULT_TUNNEL_CONFIG } from './tunnel-motion.js';

const FLOEMA_FLOATING_VISIBLE_MIN_WIDTH = 768;
const SLOW_CONNECTION_TYPES = new Set(['slow-2g', '2g']);

export function shouldInitFloemaFloatingHero(viewportWidth) {
  return toFiniteNumber(viewportWidth, 0) >= FLOEMA_FLOATING_VISIBLE_MIN_WIDTH;
}

export function getFloatingHeroProfile(viewportWidth, connection = {}) {
  const width = toFiniteNumber(viewportWidth, 0);
  const effectiveType = String(connection?.effectiveType || '').toLowerCase();
  const isSlow = connection?.saveData || SLOW_CONNECTION_TYPES.has(effectiveType);
  const adaptive =
    isSlow
      ? {
          minItems: 18,
          maxItems: 22,
          initialLoadCount: 6,
          lazyLoadBatchSize: 3,
          lazyLoadDelay: 260,
          pixelRatioCap: 1.25,
        }
      : width < 1025
        ? {
            minItems: 24,
            maxItems: 28,
            initialLoadCount: 8,
            lazyLoadBatchSize: 4,
            lazyLoadDelay: 220,
            pixelRatioCap: 1.5,
          }
        : {
            pixelRatioCap: 2,
          };

  return {
    ...DEFAULT_HERO_IMAGE_CONFIG,
    ...adaptive,
    tunnel: { ...DEFAULT_TUNNEL_CONFIG },
    portrait: {},
    renderBleedBottomRatio: 0.18,
    renderBleedXRatio: 0.12,
    autoPlay: false,
  };
}

function toFiniteNumber(value, fallback) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}
